import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AngularMaterialModule } from '../library-modules/angular-material/angular-material.module';

// components
import { HomeComponent } from './home/home.component';
import { UnauthorizedComponent } from './unauthorized/unauthorized.component';
import { TableauComponent } from './tableau/tableau.component';

@NgModule({
  declarations: [
    HomeComponent,
    UnauthorizedComponent,
    TableauComponent
  ],
  imports: [
    CommonModule,
    AngularMaterialModule
  ],
  exports: [
    HomeComponent,
    UnauthorizedComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class ComponentsModule { }
